import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/SiteManagement.css'
import siteHero from "../../../assets/images/Site Management.png";
import siteOps from "../../../assets/images/Site Management.png";

const SiteManagementPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Site Management – BuddyTech Solutions </title>
        <meta name="description" content="Efficient site operability – supervision, safety compliance, and daily progress tracking." />
        <meta name="keywords" content="site management, construction supervision" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Site Management – BuddyTech Solutions" />
        <meta property="og:description" content="Efficient site operability – supervision, safety compliance, and daily progress tracking." />
        <meta property="og:keywords" content="site management, construction supervision" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/constructions/sitemanagement" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Site Management – BuddyTech Solutions" />
        <meta name="twitter:description" content="Efficient site operability – supervision, safety compliance, and daily progress tracking." />
        <meta name="twitter:keywords" content="site management, construction supervision" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="site-container">
        <header className="site-hero">
          <div className="site-hero-content">
            <h1>Construction Site Management</h1>
            <p>
              We ensure safe, efficient, and compliant management of construction sites with real-time coordination and professional supervision.
            </p>
          </div>
          <img src={siteHero} alt="Site Management Hero" className="site-hero-img" />
        </header>

        <section className="site-section">
          <div className="site-text">
            <h2>Key Management Areas</h2>
            <p>
              Our site managers handle logistics, personnel, documentation, and progress tracking to keep your project running smoothly and safely.
            </p>
            <ul>
              <li>Daily Site Supervision & Logs</li>
              <li>Health & Safety Compliance</li>
              <li>Material & Equipment Coordination</li>
              <li>Workforce Scheduling</li>
              <li>Site Communication & Issue Resolution</li>
            </ul>
          </div>
          <img src={siteOps} alt="Site Operations" className="site-img" />
        </section>

        <section className="site-tools">
          <h2>Tools & Practices</h2>
          <div className="tools-grid">
            <span>MS Project</span>
            <span>Procore</span>
            <span>Buildertrend</span>
            <span>Bluebeam Revu</span>
            <span>PlanGrid</span>
            <span>Fieldwire</span>
            <span>Excel</span>
            <span>Site Diaries</span>
          </div>
        </section>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:vinujaya.v7@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/917010658911" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+917010658911">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default SiteManagementPage;